<form [formGroup]="form">
  <ng-container *ngIf="dokumentCtrl?.get('broj') as povezanaFakturaBrojCtrl">
    <p-autoComplete
      #autocompleteRef
      [suggestions]="dokumentSuggestionsStr"
      formControlName="searchValue"
      (completeMethod)="handleSearch($event)"
      (onSelect)="handleSelectChange($event)"
      (onBlur)="handleBlur()"
      placeholder="Unesite broj fakture i ostali podaci će automatski biti popunjeni"
      [appendTo]="parentCtrl"
      (onClear)="handleClear()"
      emptyMessage="Dokument nije pronađen"
      dropdownMode="current"
      [disabled]="shouldDisable"
      [inputStyleClass]="
        povezanaFakturaBrojCtrl.invalid &&
        (povezanaFakturaBrojCtrl.dirty || povezanaFakturaBrojCtrl.touched)
          ? 'p-invalid'
          : ''
      "
    >
    </p-autoComplete>
    <kodit-error-info-required
      [formCtrl]="povezanaFakturaBrojCtrl"
    ></kodit-error-info-required>
  </ng-container>
</form>

